import { Box } from '@mui/material';
import { AuthService } from '../../../services/auth.service';
import RoleLensBoard from './RoleLensBoard';
import UserDashboardView from '../UserDashboardView';

/**
 * The Thread style of the personal home (everyone without a role home): my own leave, expense claims and store requisitions as steps, with my attendance and leave balance.
 * The server narrows everything to the caller's own records and leaves out any section the caller has no key for, so this stays a thin wrapper.
 */
export default function PersonalLensBoard() {
    const institutionId = AuthService.getSelectedInstitution();
    return (
        <Box sx={{ minWidth: 0 }} data-help-page="dashboard.thread.personal">
            <RoleLensBoard institutionId={institutionId} lens="personal" fallback={<UserDashboardView />} />
        </Box>
    );
}
